<div style="height: fit-content; width: 100%;"  class="ctm-section">
  <div class="card-body p-3">
    <!-- Tarjetas pequeñas con datos mejorados -->
    <div class="row g-3">
      <!-- Primera fila: Información general -->
      <div class="col-12 col-sm-6 col-md-4 col-lg-2 d-flex">
        <div class="card h-100 shadow-sm border-0 w-100 rounded-3">
          <div class="card-body py-2 px-3 d-flex flex-column gap-2 align-items-center text-center">
            <span class="text-secondary text-uppercase small fw-semibold">Dispositivos</span>
            <div class="d-flex align-items-center justify-content-center gap-3">
              <div class="rounded-circle bg-info-subtle text-info d-flex align-items-center justify-content-center" style="width: 48px; height: 48px;">
                <i class="fa-solid fa-microchip"></i>
              </div>
              <span class="fs-4 fw-bold text-primary mb-0">{{ getTotalDevices() }}</span>
            </div>
            <small class="text-muted">Total en grupo</small>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-4 col-lg-2 d-flex">
        <div class="card h-100 shadow-sm border-0 w-100 rounded-3">
          <div class="card-body py-2 px-3 d-flex flex-column gap-2 align-items-center text-center">
            <span class="text-secondary text-uppercase small fw-semibold">Conectividad</span>
            <div class="d-flex align-items-center justify-content-center gap-3">
              <div class="rounded-circle bg-primary-subtle text-primary d-flex align-items-center justify-content-center" style="width: 48px; height: 48px;">
                <i class="fa-solid fa-wifi"></i>
              </div>
              <span class="fs-4 fw-bold text-primary mb-0">{{ getConnectedDevices() }}/{{ getTotalDevices() }}</span>
            </div>
            <small class="text-muted d-flex align-items-center gap-1">
              <i class="fa-solid fa-circle" [ngClass]="getConnectionPercentage() > 70 ? 'text-success' : 'text-warning'"></i>
              {{ getConnectionPercentage() }}% online
            </small>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-4 col-lg-2 d-flex">
        <div class="card h-100 shadow-sm border-0 w-100 rounded-3">
          <div class="card-body py-2 px-3 d-flex flex-column gap-2 align-items-center text-center">
            <span class="text-secondary text-uppercase small fw-semibold">Sesiones activas</span>
            <div class="d-flex align-items-center justify-content-center gap-3">
              <div class="rounded-circle bg-success-subtle text-success d-flex align-items-center justify-content-center" style="width: 48px; height: 48px;">
                <i class="fa-solid fa-play"></i>
              </div>
              <span class="fs-4 fw-bold text-primary mb-0">{{ getActiveSessions() }}</span>
            </div>
            <small class="text-muted">En uso ahora</small>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-4 col-lg-2 d-flex">
        <div class="card h-100 shadow-sm border-0 w-100 rounded-3">
          <div class="card-body py-2 px-3 d-flex flex-column gap-2 align-items-center text-center">
            <span class="text-secondary text-uppercase small fw-semibold">Consumo total</span>
            <div class="d-flex align-items-center justify-content-center gap-3">
              <div class="rounded-circle bg-warning-subtle text-warning d-flex align-items-center justify-content-center" style="width: 48px; height: 48px;">
                <i class="fa-solid fa-bolt"></i>
              </div>
              <span class="fs-4 fw-bold text-primary mb-0">{{ getTotalConsumption() }} kWh</span>
            </div>
            <small class="text-muted">Mes actual</small>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-4 col-lg-2 d-flex">
        <div class="card h-100 shadow-sm border-0 w-100 rounded-3">
          <div class="card-body py-2 px-3 d-flex flex-column gap-2 align-items-center text-center">
            <span class="text-secondary text-uppercase small fw-semibold">Coste estimado</span>
            <div class="d-flex align-items-center justify-content-center gap-3">
              <div class="rounded-circle bg-warning-subtle text-warning d-flex align-items-center justify-content-center" style="width: 48px; height: 48px;">
                <i class="fa-solid fa-euro-sign"></i>
              </div>
              <span class="fs-4 fw-bold text-primary mb-0">{{ getEstimatedCost() }}€</span>
            </div>
            <small class="text-muted">~0.168€/kWh</small>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-4 col-lg-2 d-flex">
        <div class="card h-100 shadow-sm border-0 w-100 rounded-3">
          <div class="card-body py-2 px-3 d-flex flex-column gap-2 align-items-center text-center">
            <span class="text-secondary text-uppercase small fw-semibold">Tendencia</span>
            <div class="d-flex align-items-center justify-content-center gap-3">
              <div class="rounded-circle bg-danger-subtle text-danger d-flex align-items-center justify-content-center" style="width: 48px; height: 48px;">
                <i class="fa-solid fa-chart-line"></i>
              </div>
              <span class="fs-4 fw-bold mb-0" [ngClass]="getTrendDirection() > 0 ? 'text-danger' : 'text-success'">
                <i [ngClass]="getTrendDirection() > 0 ? 'fa-solid fa-arrow-up' : 'fa-solid fa-arrow-down'"></i>
                {{ Math.abs(getTrendDirection()) }}%
              </span>
            </div>
            <small class="text-muted">vs mes anterior</small>
          </div>
        </div>
      </div>
    </div>

    <!-- Segunda fila: Estadísticas adicionales -->
    <div class="row g-3 mt-1">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
        <div class="card h-100 shadow-sm border-0 w-100 rounded-3">
          <div class="card-body py-1 px-3 d-flex flex-column align-items-center text-center gap-1">
            <h6 class="text-secondary text-uppercase small mb-0">Consumo diario promedio</h6>
            <div class="d-flex align-items-center gap-2 fs-3 text-primary fw-semibold">
              <i class="fa-solid fa-calendar-day text-info"></i>
              {{ getDailyAverageConsumption() }} kWh
            </div>
            <small class="text-muted mb-0">Promedio del mes</small>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
        <div class="card h-100 shadow-sm border-0 w-100 rounded-3">
          <div class="card-body py-1 px-3 d-flex flex-column align-items-center text-center gap-1">
            <h6 class="text-secondary text-uppercase small mb-0">Consumo medio </h6>
            <div class="d-flex align-items-center gap-2 fs-3 text-primary fw-semibold">
              <i class="fa-solid fa-chart-line text-info"></i>
              {{ getAverageConsumption() }} kWh
            </div>
            <small class="text-muted mb-0">Por equipo</small>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
        <div class="card h-100 shadow-sm border-0 w-100 rounded-3">
          <div class="card-body py-1 px-3 d-flex flex-column align-items-center text-center gap-1">
            <h6 class="text-secondary text-uppercase small mb-0">Mayor consumidor</h6>
            <div class="d-flex align-items-center gap-2 fs-3 text-primary fw-semibold">
              <i class="fa-solid fa-crown text-warning"></i>
              {{ getTopConsumerValue() }} kWh
            </div>
            <small class="text-muted mb-0">{{ getTopConsumerName() }}</small>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
        <div class="card h-100 shadow-sm border-0 w-100 rounded-3">
          <div class="card-body py-1 px-3 d-flex flex-column align-items-center text-center gap-1">
            <h6 class="text-secondary text-uppercase small mb-0">Dispositivos offline</h6>
            <div class="d-flex align-items-center gap-2 fs-3 fw-semibold" [ngClass]="getOfflineDevices() > 0 ? 'text-danger' : 'text-success'">
              <i class="fa-solid fa-triangle-exclamation"></i>
              {{ getOfflineDevices() }}
            </div>
            <small class="text-muted mb-0">Desconectados</small>
          </div>
        </div>
      </div>
    </div>

    <!-- Gráfico de consumo por dispositivo -->
    <div class="row mt-3 mb-4">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="d-flex align-items-center justify-content-between">
              <h5 class="text-muted mb-0">{{ getChartTitle() }}</h5>
            </div>
            <div class="chart-controls ms-auto d-flex justify-content-end mt-2" role="group">
              <div class="btn-group btn-group-sm" aria-label="Tipo de gráfico">
                <button type="button"
                        class="btn btn-outline-primary"
                        [ngClass]="{'active': chartViewType === 'consumption'}"
                        (click)="switchChartView('consumption')"
                        title="Ver consumo en kWh">
                  <i class="fas fa-chart-bar"></i>
                  <span class="d-none d-sm-inline ms-1">Consumo</span>
                </button>
                <button type="button"
                        class="btn btn-outline-primary"
                        [ngClass]="{'active': chartViewType === 'trend'}"
                        (click)="switchChartView('trend')"
                        title="Ver tendencia mensual">
                  <i class="fas fa-chart-line"></i>
                  <span class="d-none d-sm-inline ms-1">Tendencia</span>
                </button>
                <button type="button"
                        class="btn btn-outline-primary"
                        [ngClass]="{'active': chartViewType === 'cost'}"
                        (click)="switchChartView('cost')"
                        title="Ver coste en euros">
                  <i class="fas fa-euro-sign"></i>
                  <span class="d-none d-sm-inline ms-1">Coste</span>
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <!-- Área del gráfico -->
            <div class="chart-container-full" style="position: relative; height: 350px;" *ngIf="!loading && smartCtm && smartCtm.length > 0">
              <canvas id="ctmBarChart" #ctmBarChart></canvas>
            </div>

            <div class="d-flex justify-content-center align-items-center flex-column" style="height: 350px;" *ngIf="loading">
              <div class="spinner-border text-primary" role="status" aria-hidden="true"></div>
              <p class="text-muted mt-3 mb-0">Cargando datos CTM...</p>
            </div>

            <!-- Mensaje cuando no hay datos -->
            <div class="d-flex justify-content-center align-items-center" style="height: 350px;" *ngIf="!loading && (!smartCtm || smartCtm.length === 0)">
              <div class="text-center">
                <i class="fas fa-chart-bar fa-3x text-muted mb-3"></i>
                <h5 class="text-muted">No hay datos disponibles</h5>
                <p class="text-muted">No se encontraron dispositivos CTM para mostrar en el gráfico</p>
                <!-- Información de debug -->
                <small class="text-muted d-block mt-2">
                  Estado: smartCtm = {{ smartCtm ? 'existe' : 'null/undefined' }} |
                  Longitud: {{ smartCtm?.length || 0 }} dispositivos
                </small>
              </div>
            </div>

            <!-- Leyenda personalizada debajo del gráfico (solo para vista de consumo) -->
            <div class="row mt-3" *ngIf="!loading && chartViewType === 'consumption' && smartCtm && smartCtm.length > 0">
              <div class="col-12">
                <div class="d-flex justify-content-center flex-wrap gap-3">
                  <div *ngFor="let ctm of smartCtm; let i = index" class="legend-item-horizontal">
                    <span class="legend-color-box" [style.background-color]="deviceColors[i] || '#007bff'"></span>
                    <span class="legend-text-horizontal">
                      <strong>{{ ctm.name || 'Dispositivo ' + (i + 1) }}</strong>
                      <br>
                      <small class="text-muted">{{ ctm.serial || 'N/A' }} - {{ ctm.consumo || 0 }} kWh</small>
                    </span>
                  </div>
                </div>
                <!-- Debug info -->
                <small class="text-muted text-center d-block mt-2">
                  Mostrando {{ smartCtm.length }} dispositivos en vista de consumo
                </small>
              </div>
            </div>

            <!-- Leyenda personalizada para vista de coste -->
            <div class="row mt-3" *ngIf="!loading && chartViewType === 'cost' && smartCtm && smartCtm.length > 0">
              <div class="col-12">
                <div class="d-flex justify-content-center flex-wrap gap-3">
                  <div *ngFor="let ctm of smartCtm; let i = index" class="legend-item-horizontal">
                    <span class="legend-color-box" [style.background-color]="deviceColors[i] || '#ff6384'"></span>
                    <span class="legend-text-horizontal">
                      <strong>{{ ctm.name || 'Dispositivo ' + (i + 1) }}</strong>
                      <br>
                      <small class="text-muted">{{ ctm.serial || 'N/A' }} - {{ (ctm.consumo || 0) * 0.15 | number:'1.2-2' }}€</small>
                    </span>
                  </div>
                </div>
                <!-- Debug info -->
                <small class="text-muted text-center d-block mt-2">
                  Mostrando {{ smartCtm.length }} dispositivos en vista de coste (tarifa: 0.15€/kWh)
                </small>
              </div>
            </div>

            <!-- Información adicional para vista de coste -->
            <div class="row mt-3" *ngIf="!loading && chartViewType === 'cost'">
              <div class="col-12">
                <div class="d-flex justify-content-center align-items-center gap-4">
                  <div class="text-center">
                    <small class="text-muted d-block">Coste total mensual</small>
                    <strong class="text-success">{{ getTotalConsumption() * 0.15 | number:'1.2-2' }}€</strong>
                  </div>
                  <div class="text-center">
                    <small class="text-muted d-block">Coste diario promedio</small>
                    <strong class="text-success">{{ getTotalConsumption() * 0.005 | number:'1.2-2' }}€</strong>
                  </div>
                  <div class="text-center">
                    <small class="text-muted d-block">Tarifa promedio</small>
                    <strong class="text-primary">0.150€/kWh</strong>
                  </div>
                </div>
              </div>
            </div>

            <!-- Información adicional para vista de tendencia -->
            <div class="row mt-3" *ngIf="!loading && chartViewType === 'trend'">
              <div class="col-12">
                <div class="d-flex justify-content-center align-items-center gap-4">
                  <div class="text-center">
                    <small class="text-muted d-block">Consumo actual</small>
                    <strong class="text-primary">{{ getTotalConsumption() }} kWh</strong>
                  </div>
                  <div class="text-center">
                    <small class="text-muted d-block">Promedio mensual</small>
                    <strong class="text-primary">{{ getAverageMonthlyConsumption() }} kWh</strong>
                  </div>
                  <div class="text-center">
                    <small class="text-muted d-block">Tendencia</small>
                    <strong [ngClass]="getTrendDirection() > 0 ? 'text-danger' : 'text-success'">
                      <i [ngClass]="getTrendDirection() > 0 ? 'fas fa-arrow-up' : 'fas fa-arrow-down'"></i>
                      {{ Math.abs(getTrendDirection()) }}%
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- Tabla de dispositivos CTM -->
    <div class="row mt-4">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h5 class="text-muted mb-0">Resumen de dispositivos CTM</h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-striped table-hover">
                <thead class="table-light">
                  <tr>
                    <th>Nombre</th>
                    <th>Serial</th>
                    <th>Estado conexión</th>
                    <th>Estado operativo</th>
                    <th>Tiempo sesión</th>
                    <th>Usuario</th>
                    <th>Consumo (kWh)</th>
                    <th>Coste total (€)</th>
                    <th>Tiempo total</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let ctm of smartCtm">
                    <td>
                      <div class="badge bg-secondary-table ">
                        {{ ctm.name}}
                      </div>
                    </td>
                    <td>
                      <small class="text-muted">{{ ctm.serial }}</small>
                    </td>
                    <td>
                      <span class="badge" [ngClass]="ctm.online ? 'badge-success' : 'badge-danger'">
                        <i class="fas fa-wifi"></i>
                      </span>
                    </td>
                    <td>
                      <span class="badge bg-secondary-table">
                        <i [ngClass]="ctm.activo ? 'fas fa-play' : 'fas fa-pause'"></i>
                        {{ getCtmActiveText(ctm.activo) }}
                      </span>
                    </td>
                    <td>
                      <span *ngIf="ctm.activo" class="text-dark">
                        <i class="fa-solid fa-hourglass-half me-1 text-muted"></i>
                        <strong>{{ getCtmRemainingTime(ctm) }}</strong>
                      </span>
                      <span *ngIf="!ctm.activo" class="text-muted">
                        <i class="fa-solid fa-minus"></i> --
                      </span>
                    </td>
                    <td>
                      <span *ngIf="ctm.activo">
                        <i class="fa-solid fa-user me-1 text-muted"></i>
                        <strong>{{ getCtmCurrentUser(ctm) }}</strong>
                      </span>
                      <span *ngIf="!ctm.activo" class="text-muted">
                        <i class="fa-solid fa-minus"></i> --
                      </span>
                    </td>
                    <td>
                      <span class="fw-bold">{{ ctm.consumo }}</span> kWh
                    </td>
                    <td>
                      <span class="badge bg-success">{{ (ctm.consumo || 0) * 0.15 | number:'1.2-2' }}€</span>
                    </td>
                    <td>
                      <i class="fa-solid fa-clock me-1 text-muted"></i>
                      <span class="fw-bold">{{ getCtmTotalTime(ctm) }}</span>
                    </td>
                    <td>
                      <div class="d-flex align-items-center gap-2">
                        <a role="button"
                           class="text-secondary"
                           (click)="goToCtmDevice(ctm.serial)"
                           matTooltip="Ver detalles">
                          <i class="fas fa-eye"></i>
                        </a>
                        <a role="button"
                           class="text-secondary"
                           (click)="goToCtmSettings(ctm.serial)"
                           matTooltip="Configuración">
                          <i class="fas fa-cog"></i>
                        </a>
                        <a role="button"
                           class="text-secondary"
                           (click)="downloadCtmReport(ctm.serial)"
                           matTooltip="Descargar reporte">
                          <i class="fas fa-download"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tfoot class="table-light">
                  <tr>
                    <td colspan="6"><strong>Total</strong></td>
                    <td><strong>{{ getTotalConsumption() }} kWh</strong></td>
                    <td><strong class="text-success">{{ getTotalConsumption() * 0.15 | number:'1.2-2' }}€</strong></td>
                    <td><strong>{{ getTotalTimeFormatted() }}</strong></td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
